import Immutable from 'immutable';
import {
  FLAG_GETTING_DRIVERS_MOVEMENT_HISTORY,
  GET_DRIVERS_MOVEMENT_HISTORY,
  CLEAR_DRIVERS_MOVEMENT_HISTORY,
  FLAG_DRIVER_MOVEMENT_HISTORY_ACTIVITY,
  GET_DRIVER_MOVEMENT_HISTORY,
  CLEAR_DRIVER_MOVEMENT_HISTORY,
} from '../../../actions/types/traffic/DriverMovementHistory';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.List(),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_DRIVERS_MOVEMENT_HISTORY:
      return state.setIn(['all', 'loading'], payload);
    case GET_DRIVERS_MOVEMENT_HISTORY:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_DRIVERS_MOVEMENT_HISTORY:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_DRIVER_MOVEMENT_HISTORY_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_DRIVER_MOVEMENT_HISTORY:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case CLEAR_DRIVER_MOVEMENT_HISTORY:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    default:
      return state;
  }
};
